import {ResponsiveContent} from "../../../ResponsiveNavTabs";
import React, {useRef, useState} from "react";
import {useAlert, useAuth} from "../../../../context";
import {Link} from "react-router-dom";
import {Button, ListGroup, Stack} from "react-bootstrap";
import {
    useLocalFilter2,
    useCountry,
    useCountryCount,
    useCountryList,
    useSelect,
    useTouch,
    useLongPress,
    useCountryOrderOptions
} from "../../../../hooks";
import {
    ItemLoading,
    MenuAdd,
    MenuBar,
    MenuClearSelectButton,
    MenuConfirmDeleteButton,
    MenuOrderBy,
    MenuSearchTerm,
    OurClearAlert,
    OurPagination2,
    PageTitle
} from "../../../_components";

export function Countries() {
    return <ResponsiveContent body={<CountriesForm/>}/>
}

function CountriesForm() {
    const {userId} = useAuth()
    const {success} = useAlert()

    // Get order options
    const {orderOptions, errorOrderOptions, clearErrorOrderOptions} = useCountryOrderOptions()

    // API Actions
    const {deleteItem, errorValue, clearErrorValue} = useCountry(userId)

    // API count all items
    const {count, setCount, loadingCount, errorCount, clearErrorCount} = useCountryCount()

    // API items per page
    const {list, setList, loadingList, errorList, clearErrorList} = useCountryList()

    // Filter
    const filteredList = useLocalFilter2(list, ["name"])

    // Select
    const [selList, toggleSelectItems, clearSelectItems, isItemSelected] = useSelect(list)


    function handleOnItemsDelete() {
        selList
            .forEach(item =>
                deleteItem(item.id)
                    .then(() => {
                        setCount(count => count - 1)
                        setList(prev => prev.filter(obj => obj.id !== item.id))
                        success(`${item.name} has been deleted!`)
                    })
                    .catch(err => console.warn(err))
            )
        clearSelectItems()
    }


    return <Stack>
        <OurClearAlert variant="danger" msg={errorOrderOptions} onClear={clearErrorOrderOptions}/>
        <OurClearAlert variant="danger" msg={errorCount} onClear={clearErrorCount}/>
        <OurClearAlert variant="danger" msg={errorList} onClear={clearErrorList}/>
        <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

        <PageTitle title="Countries">Manage {filteredList.length} of {count} countries.</PageTitle>

        <MenuBar>
            <MenuAdd to="/backend/country/add" icon="plus">Add</MenuAdd>
            <MenuSearchTerm/>
            <MenuOrderBy orderOptions={orderOptions}/>
            <MenuClearSelectButton hide={selList.length === 0} onClick={clearSelectItems}>
                {selList.length} {selList.length === 1 ? "row" : "rows"}
            </MenuClearSelectButton>
            <MenuConfirmDeleteButton hide={selList.length === 0} onSubmit={handleOnItemsDelete}>
                <span>{selList.length} {selList.length === 1 ? "country" : "countries"}</span>
            </MenuConfirmDeleteButton>
        </MenuBar>

        <ItemLoading show={loadingCount || loadingList}/>

        {list && list.length > 0 ?
            <ListGroup variant="flush">
                {filteredList.map(item =>
                    <RenderItem key={item.id}
                                item={item}
                                selected={isItemSelected(item.id)}
                                selectedCount={selList.length}
                                onSelect={toggleSelectItems}
                                to={`/backend/country/${item.id}`}/>
                )}
            </ListGroup>
            :
            <span className="text-center">No country added yet</span>
        }

        <OurPagination2 loading={loadingCount || loadingList} itemCount={count}/>
    </Stack>
}


function RenderItem({item, selected, selectedCount, onSelect, to}) {
    const touch = useTouch()
    const [show, setShow] = useState(false)

    const ref = useRef(null)
    useLongPress(ref, () => onSelect(item.id))

    return (
        // <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${selected && "bg-light"} ${show && "bg-light-subtle"}`}
        <Stack direction="horizontal" gap="2" className={`mb-1 rounded ${(selected || show) && "bg-light-subtle"}`}
               onMouseEnter={() => setShow(true)}
               onMouseLeave={() => setShow(false)}>
            <Stack ref={ref} direction="horizontal" className="flex-grow-1" gap="2">
                <div>
                    {/*<i className={`bi bi-bookmark-fill fs-3 text-${item.variant}`}/>*/}
                    <i className="bi bi-flag fs-3"/>
                </div>
                <div>
                    <Stack direction="vertical" className="" gap={0}>
                        <Link to={to}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fw-semibold fs-4">{item.name}</span>
                        </Link>
                        <span className="text-wrap fs-6 fw-light">{item.code}</span>
                    </Stack>
                </div>
                {/*<div className="ms-auto">*/}
                {/*    <Stack className="text-body-tertiary align-items-end justify-content-center" gap={0}>*/}
                {/*        <span className="text-nowrap fw-normal fs-6">Media: {item.media_count}</span>*/}
                {/*        <span className="text-nowrap fw-normal fs-6">Product: {item.product_count}</span>*/}
                {/*        <span className="text-nowrap fw-normal fs-6">Device: {item.device_count}</span>*/}
                {/*    </Stack>*/}
                {/*</div>*/}
            </Stack>

            <div className="ms-auto">
                {(!touch || selected || selectedCount > 0) &&
                    <Button className="link-underline link-underline-opacity-0" variant="link" onClick={() => onSelect(item.id)}>
                        <span className={`bi ${selected ? "bi-check-square" : "bi-square"}`}></span>
                    </Button>
                }
            </div>
        </Stack>
    )
}
